module.exports = __webpack_public_path__ + "static/media/css3.5c280ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/css3.png
// module id = 198
// module chunks = 0